import React from "react";
import PropTypes from "prop-types";
import { Icon, Button, Popover, Input } from "antd";
import { MAX_UPLOAD_NUMBER } from "../../constant";
import Upload from "./Upload";
import Emoji from "./Emoji";
import "./index.css";

const { TextArea } = Input;
// 设置 Editor 组件的默认值
// 不能在 Editor.defaultProps 中设置
// 因为 Editor 在 ComponentInput 中调用
// 在 ComponentInput 中，需要使用 Editor 的 props 覆盖 ComponentInput 传入的 props
const EditorDefaultProps = {
  rows: 5,
  placeholder: "说点什么吧...",
  showEmoji: true,
  showUpload: true,
  submitText: "发表",
  onChange: () => {}
};

class Editor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showUpload: false
    };
    this.handleClickEmoji = this.handleClickEmoji.bind(this);
    this.handleShowUpload = this.handleShowUpload.bind(this);
  }

  componentDidMount() {}

  handleClickEmoji(emojiId) {
    this.props.onChangeEmoji(emojiId);
  }

  handleShowUpload(showUpload) {
    if (typeof showUpload === "boolean") {
      this.setState({ showUpload: showUpload });
    } else {
      this.setState({ showUpload: !this.state.showUpload });
    }
  }

  render() {
    const props = { ...EditorDefaultProps, ...this.props };
    const {
      value,
      onChange,
      onSubmit,
      loading,
      placeholder,
      fileList,
      onChangeFileList,
      rows,
      onUpload,
      showEmoji,
      showUpload,
      submitText
    } = props;

    return (
      <div className="editor">
        <TextArea
          value={value}
          onChange={e => onChange(e.target.value)}
          rows={rows}
          placeholder={placeholder}
        />

        <div className="toolbar">
          <div style={{ float: "left", margin: "8px 11px" }}>
            {showEmoji && (
              <Popover
                trigger="click"
                placement="bottomLeft"
                autoAdjustOverflow={false}
                content={
                  <div style={{ width: 200 }}>
                    <Emoji onClick={this.handleClickEmoji} />
                  </div>
                }
                overlayClassName="feed"
              >
                <Icon type="smile-o" className="icon" />
              </Popover>
            )}

            {showUpload && (
              <Popover
                visible={this.state.showUpload}
                overlayStyle={{ zIndex: 999 }}
                content={
                  <div
                    style={{ width: 112 * MAX_UPLOAD_NUMBER, minHeight: 100 }}
                  >
                    <Upload
                      onChangeFileList={onChangeFileList}
                      onUpload={onUpload}
                      fileList={fileList}
                    />
                  </div>
                }
                placement="bottomLeft"
                title={
                  <div style={{ margin: "5px auto" }}>
                    <span>
                      上传图片
                      <span style={{ color: "#666", fontWeight: 400 }}>
                        (您还能上传{MAX_UPLOAD_NUMBER - fileList.length}张图片)
                      </span>
                    </span>
                    <Icon
                      type="close"
                      onClick={() => this.handleShowUpload(false)}
                      style={{
                        float: "right",
                        cursor: "pointer",
                        marginTop: 4
                      }}
                    />
                  </div>
                }
              >
                <Icon
                  type="picture"
                  className="icon"
                  style={{ marginLeft: 10 }}
                  onClick={() => this.handleShowUpload(true)}
                />
              </Popover>
            )}
          </div>

          <div style={{ float: "right", margin: "5px 11px" }}>
            <Button onClick={onSubmit} type="primary" loading={loading}>
              {submitText}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

Editor.propTypes = {
  rows: PropTypes.number,
  placeholder: PropTypes.string,
  showEmoji: PropTypes.bool,
  showUpload: PropTypes.bool,
  submitText: PropTypes.string,
  onChange: PropTypes.func
};

export default Editor;
